function grow(initialValue, growthPattern) {
  let steps = [];
  let value = initialValue;
  let growthIndex = 0;

  for (let i=1; i <= 31; i++) {

    if (i > 1) {
      value += growthPattern[growthIndex];
      let nextIndex = growthIndex+1;
      growthIndex = (growthPattern[nextIndex]) ? nextIndex : 0;
    }
    steps.push( value )

  }
  return steps;
}


const Presets = {
  "fastHp": [9, 10, 10],
  "standardHp": [9],
  "slowHp": [9, 8, 8],

  "fastStat": [3, 3, 3, 2 ],
  "standardStat": [3,2 ],
  "slowStat": [2, 2, 2, 3]
};


const growthPatterns = {
  "dps": {
    hpGrowthPattern: grow(20, Presets.standardHp),
    ppGrowthPattern: grow(10, Presets.standardStat),
    atkGrowthPattern: grow(1, Presets.fastStat),
    spdGrowthPattern: grow(1, Presets.slowStat)
  },
  "disrupt": {
    hpGrowthPattern: grow(20, Presets.standardHp),
    ppGrowthPattern: grow(10, Presets.fastStat),
    atkGrowthPattern: grow(1, Presets.slowStat),
    spdGrowthPattern: grow(1, Presets.slowStat)
  },
  "support": {
    hpGrowthPattern: grow(20, Presets.fastHp),
    ppGrowthPattern: grow(10, Presets.standardStat),
    atkGrowthPattern: grow(1, Presets.slowStat),
    spdGrowthPattern: grow(1, Presets.standardStat)
  }
};

export function getGrowthPatterns(className) {
  if (!growthPatterns[className]) {
    console.warn('className not found in `getGrowthPatterns`', className)
  }
  return growthPatterns[className]
}


// WEBPACK FOOTER //
// ./src/battle/models/get-Combatant-growth-pattern.js